import React, { createContext, useState, useContext } from "react";

const ZoomContext = createContext();

export const ZoomProvider = ({ children }) => {
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem("dashZoom");
    return saved ? Number(saved) : 70;
  });

  const zoomIn  = () => setZoom((z) => { const v = Math.min(z + 10, 120); localStorage.setItem("dashZoom", v); return v; });
  const zoomOut = () => setZoom((z) => { const v = Math.max(z - 10, 40);  localStorage.setItem("dashZoom", v); return v; });

  return (
    <ZoomContext.Provider value={{ zoom, zoomIn, zoomOut }}>
      {children}
    </ZoomContext.Provider>
  );
};

export const useZoom = () => {
  const context = useContext(ZoomContext);
  if (!context) throw new Error("useZoom debe usarse dentro de ZoomProvider");
  return context;
};
